import { Box } from '@mui/material'
import { varAlpha } from 'minimal-shared/utils'
import { memo } from 'react'

import homeBannerBg from 'assets/home-bg.png'

const AppWelcomeBox = ({ sx, children }) => {
  return (
    <Box
      sx={[
        (theme) => ({
          ...theme.mixins.bgGradient({
            images: [
              `linear-gradient(to right, ${varAlpha(theme.vars.palette.grey['900Channel'], 0.75)} 0%, ${theme.vars.palette.grey[900]} 75%)`,
              `url(${homeBannerBg})`
            ]
          }),
          pt: 5,
          pb: 5,
          pr: 3,
          gap: 1,
          borderRadius: 2,
          display: 'flex',
          height: { md: 1 },
          position: 'relative',
          pl: { xs: 3, md: 5 },
          alignItems: 'center',
          color: 'common.white',
          textAlign: { xs: 'center', md: 'left' },
          flexDirection: { xs: 'column', md: 'row' },
          border: `solid 1px ${theme.vars.palette.grey[800]}`
        }),
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
    >
      {children}
    </Box>
  )
}

export default memo(AppWelcomeBox)
